/* ==========================================================================
   hc-gallery — Drag-to-Scroll Gallery
   Custom Element: <hc-gallery>
   Provides mouse drag scrolling on desktop.
   Touch/swipe works natively via overflow-x + touch-action: pan-y.
   ========================================================================== */

if (!customElements.get('hc-gallery')) {
  class HcGallery extends HTMLElement {
    constructor() {
      super();
      this.track = null;
      this.isDown = false;
      this.startX = 0;
      this.scrollStart = 0;
      this.hasMoved = false;
      this.DRAG_MULTIPLIER = 1.5;

      this.onMouseDown = this.onMouseDown.bind(this);
      this.onMouseMove = this.onMouseMove.bind(this);
      this.onMouseUp = this.onMouseUp.bind(this);
      this.onClick = this.onClick.bind(this);
    }

    connectedCallback() {
      this.track = this.querySelector('[data-js="gallery-track"]');
      if (!this.track) return;

      this.track.addEventListener('mousedown', this.onMouseDown);
      this.track.addEventListener('mousemove', this.onMouseMove);
      this.track.addEventListener('mouseup', this.onMouseUp);
      this.track.addEventListener('mouseleave', this.onMouseUp);
      this.track.addEventListener('click', this.onClick, true);
    }

    disconnectedCallback() {
      if (!this.track) return;

      this.track.removeEventListener('mousedown', this.onMouseDown);
      this.track.removeEventListener('mousemove', this.onMouseMove);
      this.track.removeEventListener('mouseup', this.onMouseUp);
      this.track.removeEventListener('mouseleave', this.onMouseUp);
      this.track.removeEventListener('click', this.onClick, true);
      this.track = null;
    }

    onMouseDown(e) {
      this.isDown = true;
      this.hasMoved = false;
      this.startX = e.pageX;
      this.scrollStart = this.track.scrollLeft;
      this.track.classList.add('is-dragging');
    }

    onMouseMove(e) {
      if (!this.isDown) return;
      e.preventDefault();
      var dx = e.pageX - this.startX;
      if (Math.abs(dx) > 3) this.hasMoved = true;
      this.track.scrollLeft = this.scrollStart - dx * this.DRAG_MULTIPLIER;
    }

    onMouseUp() {
      if (!this.isDown) return;
      this.isDown = false;
      this.track.classList.remove('is-dragging');
    }

    /** Prevent click on child links after drag */
    onClick(e) {
      if (this.hasMoved) {
        e.preventDefault();
        e.stopPropagation();
      }
    }
  }

  customElements.define('hc-gallery', HcGallery);
}
